module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Food/Bucket-f118150fb25c876a5ae62d856d9c068b.svg";